// extracted by mini-css-extract-plugin
module.exports = {"root":"tab-commercial_root__P3FpS"};